import { ButtonNew, Icon, Typography } from "@mg/dali/src";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { aboutMeEditRoute } from "../routes/AboutMe/editRoute";
import { myExpertiseEditRoute } from "../routes/MyExpertise/editRoute";
import { myWorkListRoute } from "../routes/MyWork/viewRoute";

export function EditProfileHeader() {
  const { t } = useTranslation("ui");
  const navigate = useNavigate();
  const router = useRouter();
  return (
    <div className="flex items-center justify-between border-b border-base-black pb-6">
      <Typography weight="bold" size="2xl">
        {t("userProfile.editHeader.profile")}
      </Typography>
      <div className="flex items-center gap-2">
        <ButtonNew
          variant="ghost"
          onClick={() => navigate({ to: aboutMeEditRoute.to })}
          active={router.state.location.pathname.includes("about-me")}
          data-testid="edit-profile-nav-about-me"
        >
          <Icon.User />
          About Me
        </ButtonNew>
        <ButtonNew
          variant="ghost"
          active={router.state.location.pathname.includes("my-expertise")}
          onClick={() => navigate({ to: myExpertiseEditRoute.to })}
          data-testid="edit-profile-nav-expertise"
        >
          <Icon.Star />
          Expertise
        </ButtonNew>
        <ButtonNew
          variant="ghost"
          onClick={() => navigate({ to: myWorkListRoute.to })}
          data-testid="edit-profile-nav-projects"
        >
          <Icon.Briefcase />
          Projects
          <Icon.ArrowUpRight />
        </ButtonNew>
      </div>
    </div>
  );
}
